<template>
    <div>
        <div style="width:100%;height:40px;margin-bottom:10px;">
            <div class="top_buttons" style="float:left;">
                <el-button icon="el-icon-download" @click="Download_template">下载模板</el-button>
                <el-button icon="el-icon-document" type="primary" @click="Import_users">导入名单</el-button>
                <!-- <el-button icon="el-icon-copy-document" @click="Export_users">导出名单</el-button> -->
                <!-- <el-button icon="el-icon-plus" type="primary" @click="Add_user">新增名单</el-button> -->
                <el-button icon="el-icon-user" type="warning" @click="Add_company_user">新增企业用户</el-button>
                <el-button icon="el-icon-setting" type="warning" @click="Reset_user_passwd">重置用户密码</el-button>
                <el-button icon="el-icon-refresh" type="primary" @click="Refreash_users">刷新</el-button>
                <el-dialog title="上传文件" :visible.sync="dialogFormVisible_upload" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
                    <!-- 这里给子组件传递了getUserInfo方法，供子组件调用 -->
                    <upload ref="upload_file" :getUserInfo="getUserInfo" :task_id="task_id" :refreshProgress="refreshProgress"></upload>
                    <div style="margin-top:10px;">
                        <el-button @click="dialogCancel_upload">取消</el-button>
                        <el-button type="primary" @click="uploadFile">立即上传</el-button>
                    </div>
                </el-dialog>
            </div>
            <div class="search" style="float:right;">
                <!-- 通过在form上添加@submit.native.prevent，可以支持在input上添加@keyup.native.enter，否则直接添加回车事件会有问题 -->
                <el-form :inline="true" :model="formInline" @submit.native.prevent>
                <el-form-item>
                <el-input
                placeholder="请输入搜索信息"
                v-model="formInline.search_info"
                @keyup.native.enter="search"
                clearable>
                </el-input>
                </el-form-item>
                <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
                </el-form-item>
                </el-form>
            </div>
        </div>
        <!-- <div style="margin-bottom:10px;">
            <el-alert
                :title="tips"
                type="warning"
                show-icon>
            </el-alert>
        </div> -->
    <el-table
    :data="user_list"
    style="width: 100%">
        <!-- <el-table-column prop="id" label="序号" min-width="5%"></el-table-column> -->
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="company" label="公司" min-width="8%"></el-table-column>
        <el-table-column prop="assessee" label="被评估人" min-width="8%"></el-table-column>
        <!-- <el-table-column prop="username" label="用户名" min-width="8%"></el-table-column> -->
        <el-table-column prop="email" label="邮箱" min-width="12%"></el-table-column>
        <el-table-column prop="department" label="部门" min-width="8%"></el-table-column>
        <el-table-column prop="position" label="职位" min-width="8%"></el-table-column>
        <!-- <el-table-column prop="superior" label="上级" min-width="5%"></el-table-column> -->
        <el-table-column prop="superior_Assessor" label="上级评估人" min-width="8%"></el-table-column>
        <el-table-column prop="peer_Assessor" label="peer评估人" min-width="18%"></el-table-column>
        <el-table-column prop="subordinate_Assessor" label="下级评估人" min-width="18%"></el-table-column>
        <!-- <el-table-column prop="mod_time" label="修改时间" min-width="10%"></el-table-column> -->
        <el-table-column prop="operations" label="操作" min-width="12%">
            <template slot-scope="scope">
                <!-- <el-button
                size="mini"
                @click="handleEdit(scope.row.id)">编辑</el-button> -->
                <el-button class="delete_button"
                size="mini"
                type="danger"
                @click="handleDelete(scope.row.id)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <div style="margin-top:10px;" v-if="user_list.length > 0">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageinfo.current"
            :page-sizes="pageinfo.page_sizes"
            :page-size="pageinfo.page_size"
            layout="total, sizes, prev, pager, next"
            :total="pageinfo.count">
        </el-pagination>
    </div>
    <el-dialog :title="dialog_title" 
    :visible.sync="dialogFormVisible" 
    width="800px" 
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="assessee_dialog">
        <el-form :model="form" class="dialog_form">
            <el-form-item label="被评估人" :label-width="formLabelWidth">
            <el-input v-model="form.assessee" autocomplete="off" :disabled="disable_flag"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" :label-width="formLabelWidth">
            <el-input v-model="form.email" autocomplete="off" :disabled="disable_flag"></el-input>
            </el-form-item>
            <el-form-item label="部门" :label-width="formLabelWidth">
            <!-- 这里的v-if里头貌似直接用this.xxx参数无效，所以临时在form里头增加一个operation参数 -->
            <!-- <el-select v-model="form.department" placeholder="请选择" v-if="form.operation=='edit'">
                <el-option
                v-for="(item,index) in form.department_options"
                :key="index"
                :value="item">
                </el-option>
            </el-select> -->
            <el-input v-model="form.department" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="职位" :label-width="formLabelWidth">
            <el-input v-model="form.position" autocomplete="off"></el-input>
            </el-form-item>
            <div style="margin-bottom:10px;">
                <el-alert
                    :title="dialog_tips"
                    type="warning"
                    show-icon>
                </el-alert>
            </div>
            <el-form-item label="上级评估人" :label-width="formLabelWidth">
            <el-input v-model="form.superior_Assessor" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="上级评估人邮箱" :label-width="formLabelWidth">
            <el-input v-model="form.superior_Emails" 
            autocomplete="off" 
            type="textarea" 
            :rows="2" 
            resize="none"></el-input>
            </el-form-item>
            <el-form-item label="peer评估人" :label-width="formLabelWidth">
            <el-input v-model="form.peer_Assessor" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="peer评估人邮箱" :label-width="formLabelWidth" type="textarea" :rows="2">
            <el-input v-model="form.peer_Emails" 
            autocomplete="off" 
            type="textarea" 
            :rows="2"
            resize="none"></el-input>
            </el-form-item>
            <el-form-item label="下级评估人" :label-width="formLabelWidth">
            <el-input v-model="form.subordinate_Assessor" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="下级评估人邮箱" :label-width="formLabelWidth" type="textarea" :rows="2">
            <el-input v-model="form.subordinate_Emails" 
            autocomplete="off" 
            type="textarea" 
            :rows="2" 
            resize="none"></el-input>
            </el-form-item>
            <!-- <el-form-item label="职位4" :label-width="formLabelWidth">
            <el-select v-model="form.position1" placeholder="请选择">
                <el-option
                v-for="(item,index) in form.position_options"
                :key="index"
                :value="item">
                </el-option>
            </el-select>
            </el-form-item>
            <el-form-item label="职位5" :label-width="formLabelWidth">
            <el-select v-model="form.position1" placeholder="请选择">
                <el-option
                v-for="(item,index) in form.position_options"
                :key="index"
                :value="item">
                </el-option>
            </el-select>
            </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogCancel">取 消</el-button>
            <el-button type="primary" @click="dialogSubmit">确 定</el-button>
        </div>
    </el-dialog>
    <el-dialog title="新增企业用户" :visible.sync="dialogFormVisible_company" width="500px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
        <el-form ref="company_form" :model="company_form" label-width="80px" class="company_form">
            <!-- <el-form-item label="公司名" prop="company_name">
                <el-input v-model="company_form.company_name" placeholder="公司名称"></el-input>
            </el-form-item> -->
            <el-form-item label="用户名" prop="username">
                <el-input v-model="company_form.username" placeholder="正确的邮箱名，示例：abc@sanwuguanli.com"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="company_form.password" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <div style="text-align:center;line-height:40px;">
                <el-button @click="cancle_crt">取 消</el-button>
                <el-button type="primary" @click="submit_crt">确 定</el-button>
            </div>
        </el-form>
    </el-dialog>
    <el-dialog class="reset_passwd_dialog" title="重置密码" :visible.sync="dialogFormVisible_resetpasswd" width="400px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
        <el-select v-model="reset_username" placeholder="请选择待重置密码的邮箱" style="width:260px;" clearable>
            <el-option
            v-for="item in reset_user_list"
            :key="item"
            :label="item"
            :value="item">
            </el-option>
        </el-select>
        <!-- <el-input v-model="reset_username" placeholder="请输入登录邮箱地址"></el-input> -->
        <div style="text-align:center;line-height:40px;">
            <el-button @click="cancle_reset">取 消</el-button>
            <el-button type="primary" @click="submit_reset" style="margin-top:30px;">确 定</el-button>
        </div>
    </el-dialog> 
    </div>   
</template>

<script>
import upload from "../UpLoad.vue";
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    // created() {
    //     // console.log('usermana task id: ' + this.task_id);
    //     this.getUserInfo();
    // },
    components: {
        upload
    },
    data() {
        return {
            tips: 'peer评估人和下级评估人，至少配置3个以上。',
            dialog_tips: '评估人姓名和邮箱请确保按序一一对应，多个姓名或邮箱请使用英文逗号分隔。',
            pageinfo: {
                count: 0,
                current: 1,
                page_size: 10,
                page_sizes: [1, 10, 20, 50, 100],
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            user_list: [
            //     {
            //     id: 1,
            //     userid: 123,
            //     assessee: '张三',
            //     email: 'zhangsan@126.com',
            //     department: '部门A',
            //     position: '普员',
            //     superior_Assessor: '王五',
            //     peer_Assessor: 'peer1,peer2,peer3',
            //     subordinate_Assessor: '下级a,下级b,下级c,下级d',
            //     mod_time: '2022-1-1 12:00:00',
            //     department_options: ['部门A', '部门B', '部门C', '部门D'],
            //     position_options: ['Y', 'N'],
            // },{
            //     id: 2,
            //     userid: 124,
            //     assessee: '李四',
            //     email: 'lisi@126.com',
            //     department: '部门B',
            //     position: '普员',
            //     superior_Assessor: '赵六',
            //     peer_Assessor: 'peer4,peer5,peer6,peer7',
            //     subordinate_Assessor: '下级e,下级f,下级g',
            //     mod_time: '2022-1-1 12:00:00',
            //     department_options: ['部门A', '部门B', '部门C', '部门D'],
            //     position_options: ['Y', 'N'],
            // }
            ],
            dialogFormVisible_resetpasswd: false,
            reset_username: '',
            reset_user_list: [],
            dialogFormVisible_company: false,
            dialogFormVisible_upload: false,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            form: {

            },
            company_form: {
                // company_name: '',
                username: '',
                password: '',
            },
            opertion: 'edit',
            disable_flag: true,
            dialog_title: '',
            template_file: {
                file_name: 'user-import_template.xlsx'
            },
        }
    },
    props: ['task_id'],
    methods: {
        Reset_user_passwd() {
            let params = {
                'task_id': this.task_id,
            };
            getdata.getListP("getUserList", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.reset_user_list = resp.data.data;
                    this.dialogFormVisible_resetpasswd = true;
                }else{
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    })
                }
            })
            .catch(() => {

            });
        },
        cancle_reset() {
            this.dialogFormVisible_resetpasswd = false;
        },
        submit_reset() {
            if(this.reset_username == ''){
                this.$message({
                    message: "请选择待重置密码的邮箱！",
                    type: "error",
                    duration: 6000,
                })
            }else{
                let params = {
                    'username': this.reset_username,
                    'task_id': this.task_id,
                };
                getdata.getListP("resetPasswdToDefault", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: resp.data.message,
                                type: "success",
                            })
                            this.dialogFormVisible_resetpasswd = false;
                        }else{
                            this.$message({
                                message: resp.data.message,
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                    })
                    .catch(() => {

                    });
            }
        },
        Add_company_user() {
            this.dialogFormVisible_company = true;
        },
        cancle_crt() {
            this.dialogFormVisible_company = false;
        },
        submit_crt() {
            if(this.company_form.username == '' || this.company_form.password == ''){
                this.$message({
                    message: "用户名或密码为空！",
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                })
                return;
            }else{
                // 增加对用户名（邮箱）格式的判定
                var reg = '^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$';
                //调用正则验证test()函数
                if(!this.company_form.username.match(reg)) {
                    this.$message({
                    message: "用户名格式错误，请使用正确的邮箱名！",
                    type: "error",
                    duration: 6000,
                    // showClose: true,
                    })
                    return;
                }
                // let params;
                // params = {
                //     task_id: this.task_id,
                // }
                this.company_form['task_id'] = this.task_id;
                this.company_form['user_type'] = 'company';     // 通过这个来识别创建的用户类型
                postdata.postList("addCompanyUser", JSON.stringify(this.company_form))
                .then(resp => {
                    if(resp.data.code == 200){ 
                    this.$message({
                        message: resp.data.message,
                        type: "success",
                    })
                    this.dialogFormVisible_company = false;
                    }else{ 
                    this.$message({
                        message: resp.data.message,
                        type: "error",
                        duration: 6000,
                        // showClose: true,
                    }) 
                    }                   
                })
                .catch(err => {
                    console.log(err);
                })
            }
        },
        dialogCancel() {
            // 增加处理，重新读取从后端传递过来的原始记录进行覆盖----从后台读取数据时，直接取消即可
            this.dialogFormVisible = false;  
        },
        dialogSubmit() {
            // 增加处理，将修改后的form提交后台直接更新至数据库，若成功则重新获取修改后的数据并渲染到前端
            this.dialogFormVisible = false; 
            console.log("this.form.assessee:" + this.form.assessee);
        },
        handleEdit(id) {
            // console.log('id: ' + id);
            this.dialog_title = '编辑被评估人信息',
            this.opertion = 'edit';
            this.disable_flag = true;
            // this.tmp = row;
            // 这里考虑通过row.id获取id，然后从后端查询对应的记录并绑定到this.form上。
            // this.form = row;
            this.getUserInfo(id);
            // this.form['operation'] = 'edit';
            this.dialogFormVisible = true;
            // console.log(this.form.assessee);
        },
        handleDelete(id) {
            // 这里的rows是传的整个表格的数据，网上说的用scope.row不行
            // 还是换成从后台删除，然后传最新的数据过来渲染
            // rows.splice(index, 1); 
            this.$confirm("确认删除这条记录么？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params;
                params = {
                    user_id: id,
                    task_id: this.task_id,
                }
                getdata.getListP("deleteUser", params)
                    .then(resp => {
                        if(resp.data.code == 200){
                            this.$message({
                                message: "用户已删除！",
                                type: "success",
                            })
                            this.getUserInfo();
                        }else{
                            this.$message({
                                message: "用户删除失败！",
                                type: "error",
                                duration: 6000,
                                // showClose: true,
                            })
                        }
                        // loading.close();
                    })
                    .catch(() => {
                        this.$message({
                            message: "用户删除失败！",
                            type: "error",
                            duration: 6000,
                            // showClose: true,
                        })
                    });
            }).catch(() => {
                
            })
        },
        handleSizeChange: function(size) {
            // 这里的size还有下面的currentPage都是系统自动识别到的，直接使用即可
            this.pageinfo.page_size = size;
            this.pageinfo.current = 1;
            // console.log('page_size: ' + this.pageinfo.page_size);
            if(this.formInline.search_info==''){
                this.getUserInfo();
            }else{
                this.getUserInfo(-1, this.formInline.search_info);
            }
            // console.log(this.pageinfo.page_size)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        handleCurrentChange: function(currentPage) {
            this.pageinfo.current = currentPage;
            // console.log('current: ' + this.pageinfo.current);
            if(this.formInline.search_info==''){
                this.getUserInfo();
            }else{
                this.getUserInfo(-1, this.formInline.search_info);
            }
            // console.log(this.pageinfo.current)
            // 如果后台获取的数据较大，可考虑根据分页信息从后台获取对应的信息（不全量获取）
        },
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        Import_users() {
            this.dialogFormVisible_upload = true;
        },
        Export_users() {

        },
        Add_user() {
            this.dialog_title = '新增被评估人信息';
            this.opertion = 'add';
            this.form = {};
            // this.form['operation'] = 'add';
            this.disable_flag = false;
            this.dialogFormVisible = true;
        },
        Refreash_users() {
            this.getUserInfo();
            this.$message({
                message: "刷新完成！",
                type: "success",
            })
        },
        getUserInfo(id, query_info) {
            id = id||-1;      // 设置参数默认值为-1
            query_info = query_info||'';
            // const loading = this.$loading({
            //     lock: true, // lock的修改符--默认是false
            //     text: '正在加载，请稍后...', // 显示在加载图标下方的加载文案
            //     spinner: 'el-icon-loading', // 自定义加载图标类名
            //     background: 'rgba(0, 0, 0, 0.7)', // 遮罩层颜色
            // })
            let params;
            params = {
                start: (this.pageinfo.current - 1) * this.pageinfo.page_size,
                end: (this.pageinfo.current) * this.pageinfo.page_size,
                query_info: query_info,
                user_id: id,
                task_id: this.task_id,
            }
            
            getdata.getListP("getUser", params)
            .then(resp => {
                // console.log(resp);
                if(resp.data.code == 200){
                    if(id==-1){
                        this.user_list = resp.data.data;
                        this.pageinfo.count = resp.data.count;
                    }else{
                        // 因为form是字典，所以要使用data[0]赋值
                        this.form = resp.data.data[0];
                    }  
                }
                // loading.close();
            })
            .catch(err => {
                console.log(err);
                // loading.close();
            });
        },
        dialogCancel_upload() {
            this.dialogFormVisible_upload = false;
        },
        uploadFile() {
            // 调用子组件的上传方法，结合传参，可以自由地指定后台接口
            this.$refs.upload_file.uploadFile('importUsers');
            this.dialogFormVisible_upload = false;
            // 这里不能直接使用getUserInfo()方法加载已导入的问卷，得在子组件中调用父组件的该方法完成加载
            // this.getUserInfo();
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        search() {
            // console.log('this.pageinfo.current: ' + this.pageinfo.current);
            this.getUserInfo(-1, this.formInline.search_info);
        },
    }
}
</script>

<style scoped>
/* .el-table {
    font-size: 18px;
} */
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
.search /deep/ .el-input {
    font-size: 16px;
}
.search /deep/ .el-button {
    font-size: 16px;
}
.search /deep/ .el-input__inner {
    height: 42.67px;
    line-height: 42.67px;
}
/* .el-button {
    font-size: 18px;
} */
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
/* .search /deep/ .el-input {
    font-size: 18px;
}
.search /deep/ .el-input__inner {
    height: 45px;
    line-height: 45px;
}
::v-deep .el-pagination span, ::v-deep .el-pagination button, ::v-deep .el-pager li {
    font-size: 18px;
    line-height: 45px;
    height:45px;
}
::v-deep .el-pagination__sizes .el-input .el-input__inner, ::v-deep .el-select .el-input .el-select__caret {
    font-size: 18px;
} */
.assessee_dialog /deep/ .el-dialog__body {
    padding: 20px 20px 0px 20px;
}
.dialog_form /deep/ .el-input {
    /* width: 223.67px; */
    width: 640px;
}
/* ::v-deep .el-input--mini .el-input__icon {
    line-height: 45px;
} */
.delete_button {
    margin-left: 10px;
}
::v-deep .el-form-item {
    margin-bottom: 0;
}
::v-deep .el-table__header {
    font-size: 16px;
}
.dialog_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.dialog_form /deep/ .el-textarea__inner {
    font-family: Avenir,Helvetica,Arial,sans-serif;
}
.company_form /deep/ .el-form-item {
    margin-bottom: 14px;
}
.company_form /deep/ .el-input {
    width: 320px;
}
::v-deep .el-alert__title {
    font-size: 16px;
}
::v-deep .el-alert__content {
    text-align: left;
}
.dialog_form /deep/ .el-alert__title {
    font-size: 14px;
}
::v-deep .el-dialog__footer {
    text-align: center;
}
</style>